export const PLAY_IMPRESSION = 'playImpression'
export const STREAM_IMPRESSION = 'streamImpression'
export const COMPLETE_IMPRESSION = 'completeImpression'
export const PAGE_VIEW = 'pageView'
export const CLICK = 'click'



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/constants/ImpressionType.js